module.exports = __webpack_public_path__ + "img/L_321_325.2f46a51c.png";